module.exports = __webpack_public_path__ + "img/logo-apng.4c795b21.png";